<template>

    <div class="card" v-bind:style="{backgroundColor: StatusColor(note.status)}">

        <div class="card-content">

            <div id="note-card-buttons" class="buttons is-pulled-right">

            
                <!-- hide source button when on the source page -->
                <a v-if="this.$route.name != 'share-review' && note.source_share"
                    class="button is-pulled-right">

                    <router-link :to="{ name: 'share-review', params: {'id': note.source_share} }">
                        review
                    </router-link>
                </a>

                
                <a @click="ChangeStatus(-1)"
                    class="button">
                    <b-icon
                        icon="minus"
                        size="is-small">
                    </b-icon>
                </a>
                <a @click="ChangeStatus(+1)"
                    class="button">
                    <b-icon
                        icon="plus"
                        size="is-small">
                    </b-icon>
                </a>
            </div>
            
            <div class="is-size-5">
                {{ note.note }}
            </div>

            <figure v-if="note.attachments"
                <img v-bind:src=note.attachments>
            </figure>

            <footer class="card-footer">
                <div class="card-footer-item">

                    <span v-if="note.note_taker">
                        <b-icon
                            icon="pen"
                            size="is-small">
                        </b-icon>
                        {{ note.note_taker }}
                    </span>
                </div>
                <div class="card-footer-item is-size-7">
                    updated {{ note.status_modified_date | relative_datetime }}
                </div>
                <div class="card-footer-item">
                    <span>
                        #{{ note.id }}
                    </span>
                </div>
                
            </footer>
        </div>
    </div>
</template>


<script>

    import axios from 'axios'
    import { date_filters } from '../mixins/Filters'

    export default {
        mixins: [date_filters],
        data() {
            return {
            }
        },
        props: {
            note : Object,
        },
        computed: {
        },
        methods: {
            StatusColor(status) {
                if (status == 0) {
                    return '#f36c6c80'
                }
                if (status == 1) {
                    return '#b2bb7e'
                }
                if (status == 2) {
                    return '#4aa75e'
                }
            },
            ChangeStatus(change) {
                this.note.status += change

                // limit value and dont make API calls
                if (this.note.status < 0) {
                    this.note.status = 0
                    return
                }
                if (this.note.status > 2) {
                    this.note.status = 2
                    return
                }
                
                // this makes a lot of calls to api potentially...
                let resturl = window.location.origin + '/api/notes/' + this.note.id +'/'

                // Make a formdata object to pass data to the API
                let data = {'status' : this.note.status}

                // patch is partial update
                axios
                    .patch(resturl, data)
                    .then(response => {
                        // console.info('put response', response)
                    })
                    .catch(error => console.error(error))
            }
        },
    }

</script>


<style scoped lang="scss">
    @import "../styles/_variables.scss";
    .card {
        font-size: .9em;
        margin: .5em 0;
    }
    .card-content{
        padding: 0.5em
    }
    .card-footer-item {
        padding: 0.1em;
        border-right: 1px solid rgba(0, 0, 0, .2);
    }
    .card-footer {
        border-top: 1px solid rgba(0, 0, 0, .2);
    }

    #note-card-buttons {
        margin-right: 0.5rem;
        margin-bottom: 0;
    }
    
</style>
